import React from "react";
import { Subtitle } from "./shared/Subtitle";
import { Title } from "./shared/Title";
import { styled } from "styled-components";
import PlayArrowIcon from "@mui/icons-material/PlayArrowOutlined";
import { theme } from "../theme";
import { CTAText } from "./shared/CTAText";

const Root = styled.div(
  ({ theme }) => `
  background-color: ${theme.colors.white};
`
);

const Wrapper = styled.div(
  ({ theme }) => `
  margin: 70px auto 0;
  max-width: 1000px;
  padding: 70px 5%;

  & .description {
    max-width: 750px;
    margin: 50px auto;
  }

  & .centeredText {
    max-width: 600px;
    margin: auto;
    text-align: center;
  }

  & .footerText {
    max-width: 700px;
    margin: auto;
    text-align: center;
  }
`
);

const Content = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  margin: 75px 0 40px;

  & .img-mobile {
    max-width: 600px;
    width: 100%;
    height: 330px;
    object-fit: cover;
    object-position: 40% 24%;
    border-radius: 8px;
    margin: 0 auto 50px;
  }

  & .img-desktop {
    display: none;
  }

  div {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    & .img-mobile {
      display: none;
    }

    & .img-desktop {
      display: inline;
    }
  }
`;

const ListItem = ({ title, description }) => (
  <div style={{ display: "flex", alignItems: "flexStart", marginBottom: 20 }}>
    <PlayArrowIcon style={{ color: theme.colors.blue }} />
    <span>
      <b>{title}</b> {description}
    </span>
  </div>
);

export const NotAlone = () => {
  return (
    <Root>
      <Wrapper>
        <Subtitle>Acompañamiento personalizado</Subtitle>
        <Title>Este viaje no lo haces solo</Title>
        <p className="description">
          Sabemos que empezar a programar puede ser abrumador, pero no estás
          solo. Entendemos que los bloqueos y la frustración son parte del
          proceso. Por eso, te ofrecemos un <b>trato cercano y personalizado</b>
          . Si en algún momento te sientes atascado, solo tienes que "levantar
          la mano". Tus profesores estarán ahí para resolver tus dudas, porque
          tu avance es nuestra prioridad.
        </p>
        <CTAText>
          Vamos a estar contigo durante todo el proceso de aprendizaje
        </CTAText>
        <CTAText>
          <b>Podrás contactar a tus profesores siempre que quieras</b>
        </CTAText>
        <Content>
          <img className="img-mobile" src="img/desarrollo-web.jpg" />
          <img className="img-desktop" src="img/not-alone.png" />
          <div>
            <ListItem
              title="Atención rápida: "
              description="Buscaremos solucionar tus dudas lo antes posible."
            />
            <ListItem
              title="Escuchamos y nos adaptamos a ti: "
              description="Tenemos un plan académico estructurado, pero si detectamos que varios alumnos están teniendo dudas sobre el mismo tema, adaptaremos las clases para reforzar conceptos. Tu aprendizaje es lo primero."
            />
            <ListItem
              title="Tus logros inspiran a otros: "
              description="Tras corregir las actividades, es posible que tu profesor te pida que compartas tu trabajo con el grupo. Los mejores ejercicios no solo sirven de ejemplo, sino que motivan e inspiran al resto de compañeros. Además, estas exposiciones te prepararán para futuras presentaciones a clientes cuando seas un desarrollador web profesional."
            />
            <ListItem
              title="Clases participativas: "
              description="Olvídate de los vídeos monótonos y pregrabados. Aquí, cada clase es en directo, única y llena de interacción. Te animamos a participar activamente, preguntar y resolver tus dudas al momento. Porque el aprendizaje real sucede cuando te involucras."
            />
            <ListItem
              title="Tu profesor no es tu jefe, es tu guía: "
              description="En Beyond, creemos que se aprende mejor cuando te sientes acompañado, no mandado. Aquí los profesores estan para ayudarte a pensar, a resolver problemas por tu cuenta y a que crezcas como desarrollador. Te acompañarán paso a paso, te retarán cuando sea necesario y celebrarán tus logros contigo."
            />
            <ListItem
              title="Aprende de tus compañeros y crece en equipo: "
              description="Durante el proyecto final, trabajarás codo a codo con tus compañeros, simulando un entorno laboral real. Aprenderás de ellos, enseñarás y creceréis juntos. Porque el desarrollo web no es un camino solitario: es un juego de equipo donde la colaboración y el esfuerzo conjunto son clave para el éxito."
            />
          </div>
        </Content>
        <CTAText>El mito del programador solitario ha quedado atrás</CTAText>
        <CTAText>
          Hoy los mejores proyectos nacen de{" "}
          <b>equipos unidos y comprometidos</b>
        </CTAText>
      </Wrapper>
    </Root>
  );
};
